import React from "react";
import "../styles/Services.css";

function Services() {
  return (
    <div className="services">
      <h2>Our Services</h2>
      <p>We offer a wide range of services to meet your pump needs.</p>
      <ul>
        <li>Installation</li>
        <li>Maintenance</li>
        <li>Repair</li>
        <li>Consultation</li>
      </ul>
    </div>
  );
}   
export default Services;